import React from 'react';
import { currencyFormatter } from '../valueformatter';

// Small pieces shared by the three Marketing pages so their grids and date
// handling stay consistent.

// A Postgres date/timestamp arrives as an ISO string; show just the date part.
export const formatDate = (value) => (value == null || value === '' ? '' : String(value).split('T')[0]);

// Local YYYY-MM-DD — matches ReportView, avoiding the day-shift toISOString()
// would introduce for timezones behind UTC.
export function toISODate(date) {
    const tz = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - tz).toISOString().split('T')[0];
}

// First and last day of the month containing `date`, the default range for
// spend entry (spends are usually budgeted a month at a time).
export function monthRange(date = new Date()) {
    const start = new Date(date.getFullYear(), date.getMonth(), 1);
    const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return { startDate: toISODate(start), endDate: toISODate(end) };
}

export const formatMoney = (value) =>
    value == null || value === '' ? '' : currencyFormatter(Number(value), '$');

// Right-aligned money column that stays numeric on export and sums when the
// grid is grouped — same treatment ReportView gives currency columns.
export const moneyColumn = (field, headerName) => ({
    field,
    headerName,
    type: 'rightAligned',
    filter: 'agNumberColumnFilter',
    valueFormatter: (p) => formatMoney(p.value),
    aggFunc: 'sum',
    context: { exportRaw: true },
});

// Edit / Delete buttons rendered in a grid cell. Passed the row's data via
// cellRendererParams: { onEdit, onDelete }.
export function RowActions({ data, node, onEdit, onDelete }) {
    // A pinned total row isn't a record — it has nothing to edit or delete.
    if (node && node.rowPinned) return null;
    return (
        <div className="mkt__row-actions">
            <button type="button" className="mkt__row-btn" onClick={() => onEdit(data)}>Edit</button>
            <button type="button" className="mkt__row-btn mkt__row-btn--danger" onClick={() => onDelete(data)}>Delete</button>
        </div>
    );
}

// Column definition for the RowActions cell. Pinned right and exempt from the
// grid's sort/filter/group affordances, which don't apply to buttons.
export const actionsColumn = (onEdit, onDelete) => ({
    headerName: '',
    colId: 'actions',
    cellRenderer: RowActions,
    cellRendererParams: { onEdit, onDelete },
    pinned: 'right',
    width: 150,
    minWidth: 150,
    sortable: false,
    filter: false,
    resizable: false,
    enableRowGroup: false,
    enableValue: false,
    enablePivot: false,
    suppressHeaderMenuButton: true,
    suppressMovable: true,
    // Its width is set by the buttons inside it, so keep the grid's automatic
    // sizing passes away from it.
    suppressAutoSize: true,
    suppressSizeToFit: true,
});
